import * as get from 'lodash/get';

export const getProfile = state => get( state, 'profile', {} );
export const getProfileCompanyName = state => get( getProfile( state ), 'company_name' );
export const getProfileName = state => get( getProfile( state ), 'name' );
export const getCompanyId = state => get( getProfile( state ), 'company_id' );
export const getPersonId = state => get( getProfile( state ), 'person_id' );
export const getPermissions = state => get( getProfile( state ), 'permissions.privacy-api', [] );

export const listPrivacyVersions = state =>
    getPermissions( state ).indexOf( 'list-privacy-versions' ) > -1;
export const readPrivacyVersions = state =>
    getPermissions( state ).indexOf( 'read-privacy-versions' ) > -1;
export const editVersions = state => getPermissions( state ).indexOf( 'edit-version' ) > -1;
export const enableActivateVersion = state =>
    getPermissions( state ).indexOf( 'enable-activate-version' ) > -1;
export const enableUploadPrivacyFiles = state =>
    getPermissions( state ).indexOf( 'enable-upload-privacy-files' ) > -1;
export const enableDownloadPrivacyFiles = state =>
    getPermissions( state ).indexOf( 'enable-download-privacy-files' ) > -1;
export const deletePrivacyFiles = state =>
    getPermissions( state ).indexOf( 'delete-privacy-files' ) > -1;
